document.addEventListener('DOMContentLoaded', function() {
  var modal = document.getElementById("imageModal");
  var modalThumbnailsContainer = modal.querySelector(".DesktopThumbnails__images");
  var modalMediaContainer = modal.querySelector(".ProductZoomMedia");
  var closeBtn = modal.querySelector(".ProductZoomModal__close");
  var upArrow = document.getElementById('arrow-up');
  var downArrow = document.getElementById('arrow-down');

  function updateArrowsVisibility(index, totalImages) {
    if (totalImages > 5) {
      if (index > 0) {
        upArrow.style.opacity = '1';
      } else {
        upArrow.style.opacity = '0';
      }

      if (index < totalImages - 1) {
        downArrow.style.opacity = '1';
      } else {
        downArrow.style.opacity = '0';
      }
    } else {
      upArrow.style.opacity = '0';
      downArrow.style.opacity = '0';
    }
  }

  function openModal(clickedIndex) {
    modal.style.display = "flex";
    modalThumbnailsContainer.innerHTML = ''; // Clear previous thumbnails
    modalMediaContainer.innerHTML = ''; // Clear previous images

    document.querySelectorAll('.desktop-product-sliders .product__slide').forEach(function(slide, index) {
      var imgSrc = slide.childNodes[0].dataset.imageSrc;
      var imgElement = document.createElement("img");
      imgElement.src = imgSrc;

      // Create the figure tag
      var figureElement = document.createElement("figure");
      figureElement.className = "image-wrapper image-wrapper--cover lazy-image lazy-image--backfill";
  
      // Append the img inside the figure
      figureElement.appendChild(imgElement);
  
      // Thumbnail part
      var thumbWrapper = document.createElement("button");
      thumbWrapper.className = "DesktopThumbnails__image--wrapper";
      thumbWrapper.dataset.index = index; // Add index to thumbnail
  
      // Append the figure (with the img inside) into the button (thumbWrapper)
      thumbWrapper.appendChild(figureElement.cloneNode(true));
  
      // Append the button into the thumbnails container
      modalThumbnailsContainer.appendChild(thumbWrapper);

      var mediaWrapper = document.createElement("div");
      mediaWrapper.className = "ProductZoomMedia__media--wrapper";
      mediaWrapper.id = "media-" + index; // Add ID to media wrapper
      mediaWrapper.appendChild(imgElement.cloneNode());

      modalMediaContainer.appendChild(mediaWrapper);
    });

    // Add click event to thumbnails
    modalThumbnailsContainer.querySelectorAll('.DesktopThumbnails__image--wrapper').forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        // Remove active class from all thumbnails
        modalThumbnailsContainer.querySelectorAll('.DesktopThumbnails__image--wrapper').forEach(function(t) {
          t.classList.remove('active');
        });

        // Add active class to the clicked thumbnail
        this.classList.add('active');
        
        var index = this.dataset.index;
        var targetMedia = document.getElementById("media-" + index);
        targetMedia.scrollIntoView({ behavior: 'smooth' });

        // Scroll thumbnails container
        this.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });

        // Scroll media container
        targetMedia.scrollIntoView({ behavior: 'smooth' });

        // Apply transformY effect only if index is 4
        if (index >= 4 && index < modalThumbnailsContainer.children.length - 1) {
          modalThumbnailsContainer.style.transform = `translateY(-${98 * (index - 3)}px)`;
        } else if (index <= 4) {
          modalThumbnailsContainer.style.transform = 'translateY(0)';
        }

        // Update arrows visibility
        updateArrowsVisibility(index, modalThumbnailsContainer.children.length);
      });
    });

    // Create "Back To Top" button inside a div
    var backToTopDiv = document.createElement("div");
    var backToTopButton = document.createElement("button");
    backToTopButton.className = "ProductZoomMedia__button primary-link-preset-1";
    backToTopButton.textContent = "Back To Top";
    backToTopDiv.appendChild(backToTopButton);
    modalMediaContainer.appendChild(backToTopDiv);

    // Add event listener for "Back To Top" button
    backToTopButton.addEventListener('click', function() {
      modalThumbnailsContainer.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      modal.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });

    // Use IntersectionObserver to add active class on scroll
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var index = entry.target.id.split('-')[1];

          // Remove active class from all thumbnails
          modalThumbnailsContainer.querySelectorAll('.DesktopThumbnails__image--wrapper').forEach(function(t) {
            t.classList.remove('active');
          });
          // Add active class to the corresponding thumbnail
          modalThumbnailsContainer.querySelector(`.DesktopThumbnails__image--wrapper[data-index="${index}"]`).classList.add('active');

          // Apply transformY effect only if index is 4
          if (index >= 4 && index < modalThumbnailsContainer.children.length - 1) {
            modalThumbnailsContainer.style.transform = `translateY(-${98 * (index - 3)}px)`;
          } else if (index <= 4) {
            modalThumbnailsContainer.style.transform = 'translateY(0)';
          }

          // Update arrows visibility
          updateArrowsVisibility(index, modalThumbnailsContainer.children.length);
        }
      });
    }, { threshold: 0.5 });

    // Observe each media wrapper
    modalMediaContainer.querySelectorAll('.ProductZoomMedia__media--wrapper').forEach(function(media) {
      observer.observe(media);
    });

    setTimeout(function() {
        if (clickedIndex !== undefined) {
            // Remove active class from all thumbnails
            modalThumbnailsContainer.querySelectorAll('.DesktopThumbnails__image--wrapper').forEach(function(t) {
              t.classList.remove('active');
            });
            // Add active class to the clicked thumbnail
            modalThumbnailsContainer.querySelector(`.DesktopThumbnails__image--wrapper[data-index="${clickedIndex}"]`).classList.add('active');
            var targetMedia = document.getElementById("media-" + clickedIndex);
            targetMedia.scrollIntoView({ behavior: 'smooth' });

            // Scroll thumbnail into view
            modalThumbnailsContainer.querySelector(`.DesktopThumbnails__image--wrapper[data-index="${clickedIndex}"]`).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });

            // Apply transformY effect only if index is 4
            if (clickedIndex >= 4 && clickedIndex < modalThumbnailsContainer.children.length - 1) {
              modalThumbnailsContainer.style.transform = `translateY(-${98 * (clickedIndex - 3)}px)`;
            } else if (clickedIndex < 4) {
              modalThumbnailsContainer.style.transform = 'translateY(0)';
            }

            // Update arrows visibility
            updateArrowsVisibility(clickedIndex, modalThumbnailsContainer.children.length);
        }
    }, 50);

    var images = modalThumbnailsContainer.children;
    updateArrowsVisibility(clickedIndex, images.length);
  }

  document.querySelectorAll('.desktop-product-sliders .product__slide').forEach(function(img, index) {
    img.addEventListener('click', function() {
      openModal(index);
    });
  });

  document.querySelectorAll('.product-sliders .product__slide').forEach(function(img, index) {
    img.addEventListener('click', function() {
      openModal(index);
    });
  });

  closeBtn.onclick = function() {
    modal.style.display = "none";
  }

  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  }

  // Event listeners for existing arrow buttons
  document.querySelector('.SliderButton--prev').addEventListener('click', function() {
    const activeThumb = modalThumbnailsContainer.querySelector('.DesktopThumbnails__image--wrapper.active');
    const prevThumb = activeThumb.previousElementSibling;
    if (prevThumb) {
      activeThumb.classList.remove('active');
      prevThumb.classList.add('active');
      const index = prevThumb.dataset.index;
      const targetMedia = document.getElementById("media-" + index);
      targetMedia.scrollIntoView({ behavior: 'smooth' });

      // Scroll thumbnails container
      prevThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });

      // Scroll the thumbnails container
      modalThumbnailsContainer.scrollBy({
        top: -100,
        behavior: 'smooth'
      });

      // Scroll media container
      targetMedia.scrollIntoView({ behavior: 'smooth' });

      // Apply transformY effect only if index is 4
      if (index >= 4 && index < modalThumbnailsContainer.children.length - 1) {
        modalThumbnailsContainer.style.transform = `translateY(-${98 * (index - 3)}px)`;
      } else if (index <= 4) {
        modalThumbnailsContainer.style.transform = 'translateY(0)';
      }

      // Update arrows visibility
      updateArrowsVisibility(index, modalThumbnailsContainer.children.length);
    }
  });

  document.querySelector('.SliderButton--next').addEventListener('click', function() {
    const activeThumb = modalThumbnailsContainer.querySelector('.DesktopThumbnails__image--wrapper.active');
    const nextThumb = activeThumb.nextElementSibling;
    if (nextThumb) {
      activeThumb.classList.remove('active');
      nextThumb.classList.add('active');
      const index = nextThumb.dataset.index;
      const targetMedia = document.getElementById("media-" + index);
      targetMedia.scrollIntoView({ behavior: 'smooth' });

      // Scroll thumbnails container
      nextThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });

      // Scroll the thumbnails container
      modalThumbnailsContainer.scrollBy({
        top: 100,
        behavior: 'smooth'
      });

      // Scroll media container
      targetMedia.scrollIntoView({ behavior: 'smooth' });

      // Apply transformY effect only if index is 4
      if (index >= 4 && index < modalThumbnailsContainer.children.length - 1) {
        modalThumbnailsContainer.style.transform = `translateY(-${98 * (index - 3)}px)`;
      } else if (index <= 4) {
        modalThumbnailsContainer.style.transform = 'translateY(0)';
      }

      // Update arrows visibility
      updateArrowsVisibility(index, modalThumbnailsContainer.children.length);
    }
  });
});